<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1B1ZDkG/OEBPS/images/9781443148948_Outside_Front_Cover.jpg?1684515197371" alt="This image is the cover for the book Ice Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ice Time
      </h1>
      <p class="bookDescription body article font2">
        <p>Rocket has finally achieved his dream  hes been drafted to the NHL!</p><p>Following a great Major Junior career, Rocket is drafted in the NHL draft! However, the scouts still feel that Rocket needs some retooling to be an NHLer. He is sent to the AHL for seasoning, and told he should hit the weight room as well.</p><p>At home, Maddy has applied for loans for her first year of university. Rocket assures her that hell pay it all off when hes a pro. This changes when his mother is laid off and Rockets income is all the family has  and an AHL salary doesnt go very far.</p><p>Through his training with the AHL, Rocket will face many challenges, both on the ice and in his home life. Will Rocket once again beat the odds?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Skuy
      </h2>
      
      <p class="authorDescription body article"><p><strong>DAVID SKUY</strong> is a lawyer, a writer and a Leafs fan to the core. He spent most of his childhood playing some sport or another: hockey, soccer, football, tennis and a few others. What he remembers most is the intensity, the competitiveness, and the sheer enjoyment of playing a sport you love when you're young.</p><p>He has written five books in the Game Time series, a standalone novel called <i>Undergrounders</i>, winner of the Silver Birch Award, and two previous, multi-award nominated books about Bryan "Rocket" Rockwood, <i>Rocket Blues</i> and <i>Last Shot</i>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic Canada Ltd.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d7cb7b6